import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  position: fixed;
  height: 100vh;
  width: 100%;
`;
